import { Skeleton } from '@/components/ui/skeleton'

export const EmpreendimentoMidiasPageSkeleton = () => {
  const SKELETON_IDS = Array.from({ length: 12 }, (_, i) => `empreendimento-midia-skeleton-${i}`)

  return (
    <div data-testid="empreendimento-midias-skeleton">
      <div className="grid gap-6">
        <div>
          <Skeleton className="mb-2 h-6 w-48" />
          <Skeleton className="h-4 w-96" />
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {SKELETON_IDS.map((skeletonId) => (
            <div key={skeletonId} className="aspect-square">
              <Skeleton className="h-full w-full rounded-lg" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
